/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronUp: {
  name: 'chevron-up';
  data: string;
} = {
  name: 'chevron-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.293 9.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L12 11.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4Z" fill="currentColor"/></svg>`,
};
